import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    slots: {
        description: 'whitespace-pre-line wrap-anywhere'
    }
} satisfies NuxtUiTheme['toast'];
